import React, { ChangeEvent, useEffect, useState } from "react";
import { Box, Button, Container, Stack } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Badge from "@mui/material/Badge";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutorenewIcon from "@mui/icons-material/Autorenew";

import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { Product, ProductInquiry } from "../../../lib/types/product";
import { setProducts } from "./slice";
import { createSelector } from "reselect";
import { retreiveProducts } from "./selector";
import ProductService from "../../services/ProductService";
import { ProductCollection } from "../../../lib/enums/product.enum";
import { serverApi } from "../../../lib/config";
import { useHistory } from "react-router-dom";
import { CartItem } from "../../../lib/types/search";

/** REDUX SLICE & SELECTOR */
const actionDispatch = (dispatch: Dispatch) => ({
  setProducts: (data: Product[]) => dispatch(setProducts(data)),
});

const productsRetreiver = createSelector(retreiveProducts, (products) => ({
  products,
}));

interface ProductsProps {
  onAdd: (item: CartItem) => void;
}

export default function Products(props: ProductsProps) {
  const { onAdd } = props;
  const { setProducts } = actionDispatch(useDispatch());
  const { products } = useSelector(productsRetreiver);
  const [productSearch, setProductSearch] = useState<ProductInquiry>({
    page: 1,
    limit: 8,
    order: "createdAt",
    search: "",
  });

  const [searchText, setSearchText] = useState<string>("");
  const history = useHistory();

  useEffect(() => {
    const product = new ProductService();
    product
      .getProducts(productSearch)
      .then((data) => {
        setProducts(data);
      })
      .catch((err) => console.log(err));
  }, [productSearch]);

  useEffect(() => {
    if (searchText === "") {
      productSearch.search = "";
      setProductSearch({ ...productSearch });
    }
  }, [searchText]);

  /** HANDLERS */
  const serachCollectionHandler = (collection: ProductCollection) => {
    productSearch.page = 1;
    productSearch.productCollection = collection;
    setProductSearch({ ...productSearch });
  };

  const serachOrderHandler = (order: string) => {
    productSearch.page = 1;
    productSearch.order = order;
    setProductSearch({ ...productSearch });
  };

  const serachProductHandler = () => {
    productSearch.search = searchText;
    setProductSearch({ ...productSearch });
  };

  const paginationHandler = (e: ChangeEvent<any>, value: number) => {
    productSearch.page = value;
    setProductSearch({ ...productSearch });
  };

  const chooseProductHandler = (id: string) => {
    history.push(`/products/${id}`);
  };
  const resetAllProductHandler = () => {
    productSearch.page = 1;
    productSearch.limit = 8;
    productSearch.order = "createdAt";
    productSearch.search = "";
    productSearch.productCollection = undefined;
    setProductSearch({ ...productSearch });
  };

  return (
    <div className={"products"}>
      <Container>
        <Stack flexDirection={"column"} alignItems={"center"}>
          <Stack className={"avatar-big-box"}>
            <Stack className={"top-text"}>
              <Box className={"main-title"}>Beautify Cosmetics</Box>
              <Stack className={"search-section"}>
                <input
                  type={"search"}
                  placeholder={"Type here"}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") serachProductHandler();
                  }}
                ></input>
                <Button
                  variant={"contained"}
                  className={"search-btn"}
                  sx={{
                    borderRadius: "12.5px",
                    background: "#034001",
                    color: "white",
                  }}
                  onClick={serachProductHandler}
                >
                  Search
                  <SearchIcon
                    sx={{
                      width: "14px",
                      height: "15px",
                      marginLeft: "7px",
                      marginBottom: "6px",
                    }}
                  />
                </Button>
                <Button>
                  <AutorenewIcon
                    sx={{
                      marginRight: "0px",
                    }}
                    onClick={resetAllProductHandler}
                  />
                </Button>
              </Stack>
            </Stack>
          </Stack>
          <Stack className={"products-filter-section"}>
            <Stack className={"products-filter-box"}>
              <Button
                variant={"contained"}
                sx={
                  productSearch.order === "createdAt"
                    ? { background: "#034001", color: "white" }
                    : { background: "#adf7b6", color: "black" }
                }
                className={"order"}
                onClick={() => serachOrderHandler("createdAt")}
              >
                New
              </Button>
              <Button
                variant={"contained"}
                sx={
                  productSearch.order === "productPrice"
                    ? { background: "#034001", color: "white" }
                    : { background: "#adf7b6", color: "black" }
                }
                className={"order"}
                onClick={() => serachOrderHandler("productPrice")}
              >
                Price
              </Button>
              <Button
                variant={"contained"}
                sx={
                  productSearch.order === "productViews"
                    ? { background: "#034001", color: "white" }
                    : { background: "#adf7b6", color: "black" }
                }
                className={"order"}
                onClick={() => serachOrderHandler("productViews")}
              >
                Views
              </Button>
            </Stack>
          </Stack>
          <Stack className={"list-category-section"}>
            <Stack className={"product-category"}>
              <div className={"category-main"}>
                <Button
                  variant={"contained"}
                  sx={
                    productSearch.productCollection ===
                    ProductCollection.PERSONALCARE
                      ? { background: "#034001", color: "white" }
                      : { background: "#adf7b6", color: "black" }
                  }
                  className={"menu-btn"}
                  onClick={() =>
                    serachCollectionHandler(ProductCollection.PERSONALCARE)
                  }
                >
                  Personal Care
                </Button>
                <Button
                  variant={"contained"}
                  sx={
                    productSearch.productCollection ===
                    ProductCollection.FRAGRANCE
                      ? { background: "#034001", color: "white" }
                      : { background: "#adf7b6", color: "black" }
                  }
                  className={"menu-btn"}
                  onClick={() =>
                    serachCollectionHandler(ProductCollection.FRAGRANCE)
                  }
                >
                  Fragnance
                </Button>
                <Button
                  variant={"contained"}
                  sx={
                    productSearch.productCollection === ProductCollection.MAKEUP
                      ? { background: "#034001", color: "white" }
                      : { background: "#adf7b6", color: "black" }
                  }
                  className={"menu-btn"}
                  onClick={() =>
                    serachCollectionHandler(ProductCollection.MAKEUP)
                  }
                >
                  Makeup
                </Button>
                <Button
                  variant={"contained"}
                  sx={
                    productSearch.productCollection ===
                    ProductCollection.HAIRCARE
                      ? { background: "#034001", color: "white" }
                      : { background: "#adf7b6", color: "black" }
                  }
                  className={"menu-btn"}
                  onClick={() =>
                    serachCollectionHandler(ProductCollection.HAIRCARE)
                  }
                >
                  Haircare
                </Button>
                <Button
                  variant={"contained"}
                  sx={
                    productSearch.productCollection ===
                    ProductCollection.SKINCARE
                      ? { background: "#034001", color: "white" }
                      : { background: "#adf7b6", color: "black" }
                  }
                  className={"menu-btn"}
                  onClick={() =>
                    serachCollectionHandler(ProductCollection.SKINCARE)
                  }
                >
                  Skincare
                </Button>
              </div>
            </Stack>
            <Stack className={"product-wrapper"}>
              {products.length !== 0 ? (
                products.map((product: Product) => {
                  const imagePath = `${serverApi}/${product.productImages[0]}`;

                  return (
                    <Stack
                      key={product._id}
                      className={"product-card"}
                      onClick={() => chooseProductHandler(product._id)}
                    >
                      <Stack
                        className={"product-img"}
                        sx={{ backgroundImage: `url(${imagePath})` }}
                      >
                        <div className={"product-sale"}>Sale</div>
                        <Button
                          className={"shop-btn"}
                          onClick={(e) => {
                            onAdd({
                              _id: product._id,
                              quantity: 1,
                              name: product.productName,
                              price: product.productPrice,
                              image: product.productImages[0],
                            });
                            e.stopPropagation();
                          }}
                        >
                          <img
                            src={"/icons/shopping-cart.svg"}
                            style={{ display: "flex" }}
                            alt=""
                          />
                        </Button>
                        <Button className={"view-btn"} sx={{ right: "36px" }}>
                          <Badge
                            badgeContent={product.productViews}
                            color="secondary"
                          >
                            <RemoveRedEyeIcon
                              sx={{
                                color:
                                  product.productViews === 0 ? "gray" : "white",
                              }}
                            />
                          </Badge>
                        </Button>
                      </Stack>
                      <Box className={"product-desc"}>
                        <span className={"product-title"}>
                          {product.productName}
                        </span>
                        <div className={"product-price"}>
                          <MonetizationOnIcon />
                          {product.productPrice}
                        </div>
                      </Box>
                    </Stack>
                  );
                })
              ) : (
                <Box className="no-data">Products are not available</Box>
              )}
            </Stack>
          </Stack>
          <Stack className={"pagination-section"}>
            <Pagination
              count={
                products.length !== 0
                  ? productSearch.page + 1
                  : productSearch.page
              }
              page={productSearch.page}
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: ArrowBackIcon,
                    next: ArrowForwardIcon,
                  }}
                  {...item}
                  color={"secondary"}
                />
              )}
              onChange={paginationHandler}
            />
          </Stack>
        </Stack>
      </Container>
      <div className={"brand-logo"}>
        <Container className={"family-brands"}>
          <Box className={"category-title"}>Celebrity Users</Box>
          <Stack className={"brand-list"}>
            <Box className={"review-box"}>
              <img src={"/img/selena.jpg"} alt="" />
            </Box>
            <Box className={"review-box"}>
              <img src={"/img/rihanna.webp"} alt="" />
            </Box>
            <Box className={"review-box"}>
              <img src={"/img/emma.webp"} alt="" />
            </Box>
            <Box className={"review-box"}>
              <img src={"/img/ariana.jpg"} alt="" />
            </Box>
          </Stack>
        </Container>
      </div>
      <div className={"address"}>
        <Container>
          <Stack className={"address-area"}>
            <Box className={"title"}>Our Address</Box>
            <iframe
              title="1"
              style={{ marginTop: "60px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11633.464101636637!2d127.05468676953599!3d37.499986905929966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca4235fb589fb%3A0xb331971bc570bb6a!2sGangnam%20District%2C%20Seoul!5e0!3m2!1sen!2skr!4v1736940950981!5m2!1sen!2skr"
              width="1320"
              height="567.84"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Stack>
        </Container>
      </div>
    </div>
  );
}
